module.exports = __webpack_public_path__ + "img/newsletter-sign-up.2a60a8fb.png";